import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import useMediaQuery from '@material-ui/core/useMediaQuery';

import DefaultCrest from "../../assets/default-crest.svg";
import LazyImage from "./lazy-load";

import { commonStyles } from "../../styles";

const useStyles = makeStyles({
	root: {
		width: props => (props.fullWidth ? "100%" : "auto")
	},
	prefix: {
		margin: "0 8px 0 0"
	},
	teamBadge: {
		margin: "0 4px 0 0",
		marginLeft: props => (props.ml ? "4px" : "0px"),
		width: "15px",
	},
	teamFlag: {
		display: "flex",
		margin: "0px 8px 0px 0px",
		marginLeft: props => (props.ml ? "4px" : "0px"),
		width: 18,
		height: 11
	},
	teamBadgeRight: {
		margin: "0 0 0 4px!important",
	},
	teamFlagRight: {
		margin: "0px 0px 0px 8px!important",
	},
	teamServing: {
		display: "flex",
		margin: "0px 0px 0px 0px",
		width: 11,
		height: 11
	},
	teamImg: {
		display: "block",
		width: "auto",
		height: "15px",
		margin: "0 auto",
		maxWidth: "15px",
	},
	teamName: {
		fontSize: 12,
		fontWeight: 600,
		wordBreak: "normal",
		textAlign: "left",
		color: props => props.color,
		width: props => (props.fullWidth ? "100%" : "auto")
	},
	bigger: {
		fontSize: 14,
	}
});

const Team = props => {
	const ccls = commonStyles();
	const cls = useStyles(props);

	const { prefix, name, badge, flag, serving, className, right } = props;
	let isDesktop = useMediaQuery('(min-width:1400px)');

	return (
		<div className={clsx(ccls.horizontalFlex, cls.root, className ? className : "")}>
			{prefix !== "" && <div className={cls.prefix}>{prefix}</div>}
			{badge !== null && !right && (
				<div className={`${cls.teamBadge} teamBadge`}>
					<img className={cls.teamImg} src={badge} alt="" />
				</div>
			)}
			{flag !== null && !right && (
				<div className={`${cls.teamFlag} teamFlag`}>
					<img className={cls.teamImg} src={flag} alt="" />
				</div>
			)}
			{serving !== null && !right && (
				<div className={`${cls.teamServing} teamServing`}>
					{serving === true && (<svg><circle cx="5" cy="5" r="3" fill="yellow" /></svg>)}
				</div>
			)}
			<div className={`${cls.teamName} ${isDesktop ? '' : cls.bigger} teamName`}>{name}</div>
			{badge !== null && right && (
				<div className={`${cls.teamBadge} ${cls.teamBadgeRight} teamBadge`}>
					<img className={cls.teamImg} src={badge} alt="" />
				</div>
			)}
			{flag !== null && right && (
				<div className={`${cls.teamFlag} ${cls.teamFlagRight} teamFlag`}>
					<img className={cls.teamImg} src={flag} alt="" />
				</div>
			)}
			{serving !== null && right && (
				<div className={`${cls.teamServing} teamServing`}>
					{serving === true && (<svg><circle cx="5" cy="5" r="3" fill="yellow" /></svg>)}
				</div>
			)}
		</div>
	);
};

Team.propTypes = {
	name: PropTypes.string,
	color: PropTypes.string,
	prefix: PropTypes.string,
	badge: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	flag: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	serving: PropTypes.bool,
	ml: PropTypes.bool,
	fullWidth: PropTypes.bool
};

Team.defaultProps = {
	name: "Default name",
	color: "#17214D",
	prefix: "",
	badge: null,
	flag: null,
	serving: null,
	ml: false,
	fullWidth: false
};

export default React.memo(Team);
